<script setup lang="ts">
import { computed } from "vue";
const page = usePage().value;

const caseStudies = computed(() => page?.caseStudies ?? []);

const currentSlide = ref(0);
const { isMobile } = useIsMobile();
const windowWidth = ref(0);
const itemsToShow = ref(3);
const itemsToScroll = ref(1);
const wrapAround = ref(true);

function updateWidth() {
  if (process.client) {
    windowWidth.value = window.innerWidth;

    if (isMobile.value) {
      itemsToShow.value = 1;
    } else {
      itemsToShow.value = 1;
    }
  }
}

onMounted(() => {
  updateWidth();
  window.addEventListener("resize", updateWidth);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWidth);
});
</script>

<template>
  <div id="caseStudies">
    <header>
      <h2>Case Studies</h2>
    </header>

    <ClientOnly>
      <Carousel
        v-model="currentSlide"
        :items-to-show="itemsToShow"
        :items-to-scroll="itemsToScroll"
        :wrap-around="wrapAround"
      >
        <Slide v-for="(caseStudy, index) in caseStudies" :key="caseStudy.id">
          <div class="carousel__item">
            <div class="case-study-content">
              <h3>
                <span class="case-number">{{ index + 1 }}</span>
                <span>{{ caseStudy.title }}</span>
              </h3>
              <div class="case-study-text" v-html="caseStudy.text" />
            </div>
          </div>
        </Slide>
        <template #addons>
          <Navigation />
          <Pagination />
        </template>
      </Carousel>

      <template #fallback>
        <div class="case-studies-loading">
          <div class="loading-placeholder">
            <div class="loading-shimmer"></div>
          </div>
        </div>
      </template>
    </ClientOnly>
  </div>
</template>
